import React, {FC, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {addressService, tokenService} from "../../store/actions";
import useCommon from "../../common/hooks/useCommon";
import BTooltip from "../../components/b-tooltip";
import AddressName from "../common/address-name";
import BCopy from "../../components/b-copy";
import XRC721TokenTransferList from "../common/xrc721-token-transfer-list";
import {useSelector} from "react-redux";
import NFTImage from "./common/nft-image";
import {centerTruncate, truncate} from "../../common/utils/function";
import {useTranslation} from "react-i18next";
import TokenImage from "../common/token-image";

interface TransactionListData {
    animation_url?: any,
    external_app_url?: string,
    id?: string,
    image_url?: string,
    is_unique?: boolean,
    metadata?: any,
    owner?: any,
    token?: any
}


const NFTDetails: FC = () => {
    const {getXDC, get0x} = useCommon();
    const _tokenType = useSelector((e: Object) => (e as any)?.common?.tokenType);
    const {token, id} = useParams();
    const {t, i18n} = useTranslation();

    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState<TransactionListData>({
        animation_url: "",
        external_app_url: "",
        id: "",
        image_url: "",
        is_unique: false,
        metadata: null,
        owner: null,
        token: null
    });
    const [addressStats, setAddressStats] = useState<any>({});

    const getToken = async () => {
        try {
            setLoading(true);
            tokenService.getNFTToken(token, id).then(response => {
                setStats(response)
                setLoading(false);
            })
            addressService.getAddress(token).then((response) => {
                setAddressStats(response);
            }).catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getToken();
    }, [])

    return <div className="py-3">
        <div className="container">
            <div className="row">
                <div className="col-lg-5 px-3 mb-4">
                    <div className="bs-card">
                        <NFTImage image={stats?.image_url}/>
                    </div>
                </div>
                <div className="col-lg-7 px-3 mb-4">
                    <div className="bs-page-title border-0 d-block m-0">
                        {/* {stats?.metadata?.name && truncate(stats?.metadata?.name, 24)} */}

                        <p className="bs-page-title-secondary m-0">
                            {stats?.token?.name} #{stats?.id} <br/>

                            <Link to={`/token/${stats?.token?.address}`}>
                                <TokenImage image={stats?.token?.icon_url} symbol={stats?.token?.symbol} params={{width: 20, className: "me-1"}}/>
                                {stats?.token?.name}


                            </Link>
                        </p>
                    </div>
                    <div className="bs-card mb-3 shadow-none">
                        <div className="bs-card-body p-3">
                            <div className="row gx-4">
                                <div className="col-md-12 col-lg-4">
                                    <p className="bs-font-secondary">{t("Min Price")} (24H)</p>
                                    <p className="bs-font">N/A</p>
                                </div>
                                <div className="col-md-12 col-lg-4 border-start">
                                    <p className="bs-font-secondary">{t("Last Sale")} ({t("Item")})</p>
                                    <p className="bs-font">N/A</p>
                                </div>
                                <div className="col-md-12 col-lg-4 border-start">
                                    <p className="bs-font-secondary">{t("Last Sale")} ({t("Contract")})</p>
                                    <p className="bs-font">N/A</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="accordion" id="accordionPanelsStayOpenExample">
                        <div className="accordion-item mb-4">
                            <h2 className="accordion-header">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                        aria-controls="panelsStayOpen-collapseOne">
                                    {t("Details")}
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show">
                                <div className="accordion-body">
                                    <div className="bs-list">
                                        {stats?.owner?.hash && <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip text={t("Current owner of this NFT.")}><i className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Owner")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                <Link to={`/address/${get0x(stats?.owner?.hash)}/#nfttransfers`}><AddressName
                                                    data={stats?.owner}/></Link><BCopy value={getXDC(stats?.owner?.hash)}/>
                                            </div>
                                        </div>}
                                        <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip text={t("Address of this NFT contract.")}><i className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Contract Address")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                <Link
                                                    to={`/address/${get0x(stats?.token?.address)}`}>{centerTruncate(getXDC(stats?.token?.address))}</Link><BCopy
                                                value={getXDC(stats?.token?.address)}/>
                                            </div>
                                        </div>
                                        {addressStats?.creator_address_hash && <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip text={t("Address that deployed this NFT contract.")}><i className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Creator")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                <Link
                                                    to={`/address/${get0x(addressStats?.creator_address_hash)}?address=${get0x(addressStats?.creator_address_hash)}`}>{centerTruncate(getXDC(addressStats?.creator_address_hash))}</Link><BCopy
                                                value={getXDC(addressStats?.creator_address_hash)}/>
                                            </div>
                                        </div>}
                                        {addressStats?.classification && <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip
                                                    text={t("Classification of NFT based on how the image is stored: On-Chain refers to those with data stored on the blockchain while Off-Chain refers to those with data stored elsewhere on the Internet.")}><i
                                                    className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Classification")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                :{t("ToDo")}
                                            </div>
                                        </div>}
                                        {stats?.id && <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip text={t("This NFT's unique token ID.")}><i className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Token ID")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                {truncate(stats?.id, 24)} <BCopy value={stats?.id}/>
                                            </div>
                                        </div>}
                                        <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip text={t("The standard followed by this NFT.")}><i className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Token Standard")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                {addressStats?.token?.type === 'ERC-20' ? `${_tokenType}-20` : addressStats?.token?.type === 'ERC-404' ? `${_tokenType}-404` : addressStats?.token?.type === 'ERC-721' ? `${_tokenType}-721` : `${_tokenType}-1155`}
                                            </div>
                                        </div>
                                        {addressStats?.marketplaces && <div className="bs-list-row">
                                            <div className="bs-list-title w-40">
                                                <BTooltip text={t("Marketplaces trading this NFT.")}><i className="bi bi-question-circle me-2"></i></BTooltip>
                                                {t("Marketplaces")}:
                                            </div>
                                            <div className="bs-list-content w-60">
                                                :{t("ToDo")}
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {stats?.metadata?.attributes?.length && <div className="accordion-item mb-4">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo"
                                        aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                                    {t("Properties")}
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse">
                                <div className="accordion-body">
                                    <div className="row gx-2 gy-2">

                                        {stats?.metadata?.attributes?.map((data: any, i: number) => {
                                            return <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-xs-12" key={i}>
                                                <div className="bs-card bg-light shadow-none text-center p-2">
                                                    <p className="bs-small-font bs-font-primary fw-bold">{data?.trait_type}</p>
                                                    <p className="bs-font">{data?.value}</p>
                                                    {/*<p className="bs-small-font bs-font-secondary">:ToDo Rarity: 1.2%</p>*/}
                                                </div>
                                            </div>
                                        })}

                                    </div>
                                </div>
                            </div>
                        </div>}
                        {stats?.metadata?.description && <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"
                                        aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                    {t("Description")}
                                </button>
                            </h2>
                            <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse">
                                <div className="accordion-body">
                                    <div className="row gx-2 gy-2">

                                        {stats?.metadata?.description}

                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <XRC721TokenTransferList count={5}/>
                </div>
            </div>
        </div>
    </div>
};

export default NFTDetails;
